import { ChevronUp, HelpCircle, LogOut, Settings, Shield, User } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useProfileStore } from "../stores/profileStore";

export const UserProfile = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { profile } = useProfileStore();

  const handleLogout = () => {
    // Assuming there's a logout function in the profile store
    // logout();
    setIsOpen(false);
  };

  return (
    <div className="relative mt-2">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-[9px] py-1 flex items-center justify-between hover:bg-zinc-800 rounded-md transition-colors"
      >
        <div className="flex items-center gap-3">
          {profile.avatar ? (
            <img src={profile.avatar} alt={profile.name} className="w-8 h-8 rounded-full" />
          ) : (
            <div className="w-8 h-8 bg-zinc-700 rounded-full flex items-center justify-center">
              <User className="w-5 h-5" />
            </div>
          )}
          <span className="font-medium max-w-[200px] overflow-hidden text-ellipsis whitespace-nowrap">
            {profile.name || "User"}
          </span>
        </div>
        <ChevronUp className={`w-4 h-4 transition-transform ${isOpen ? "" : "rotate-180"}`} />
      </button>

      {isOpen && (
        <div className="absolute bottom-full left-0 w-full mb-2 bg-zinc-800 rounded-md shadow-lg py-1 z-[60]">
          <button
            onClick={() => {
              navigate("/profile");
              setIsOpen(false);
            }}
            className="w-full px-4 py-2 flex items-center gap-3 hover:bg-zinc-700 text-left"
          >
            <User className="w-4 h-4" />
            <span>Profile</span>
          </button>
          <button
            onClick={() => {
              navigate("/settings");
              setIsOpen(false);
            }}
            className="w-full px-4 py-2 flex items-center gap-3 hover:bg-zinc-700 text-left"
          >
            <Settings className="w-4 h-4" />
            <span>Settings</span>
          </button>
          <button
            onClick={() => {
              navigate("/privacy");
              setIsOpen(false);
            }}
            className="w-full px-4 py-2 flex items-center gap-3 hover:bg-zinc-700 text-left"
          >
            <Shield className="w-4 h-4" />
            <span>Privacy</span>
          </button>
          <button
            onClick={() => {
              navigate("/help");
              setIsOpen(false);
            }}
            className="w-full px-4 py-2 flex items-center gap-3 hover:bg-zinc-700 text-left"
          >
            <HelpCircle className="w-4 h-4" />
            <span>Help</span>
          </button>
          <div className="border-t border-zinc-700 my-1" />
          <button
            onClick={handleLogout}
            className="w-full px-4 py-2 flex items-center gap-3 hover:bg-zinc-700 text-red-400 hover:text-red-300 text-left"
          >
            <LogOut className="w-4 h-4" />
            <span>Log out</span>
          </button>
        </div>
      )}
    </div>
  );
};
